
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { VuetifyMixin, BAIconsMixin, SportsSelectorMixin } from '../../mixins';

@Component
export default class SportSelector extends Mixins(VuetifyMixin, BAIconsMixin, SportsSelectorMixin) {
	@Prop({ default: () => [] }) value: string[];
	input(value: string[]): void{
		this.$emit('input', value);
	}
}
